<template>
  <div>
    <div id="gridcontainer">
      <table id="activeTable" class="upcoming-table" style="padding-right: 2px;">
        <thead>
          <tr id="activeTable-header-row">
            <th style="width: 7%">Driver</th>
            <th style="width: 4%">Ptime</th>
            <th style="width: 8%">ETA</th>
            <th style="width: 28%">Pickup</th>
            <th style="width: 4%">Via</th>
            <th style="width: 28%">Destination</th>
            <th style="width: 6%">Room/Name</th>
            <th style="width: 6%">Att</th>
          </tr>
        </thead>
        <ActiveTaxiTableRows
          :setSelectedBooking="setSelectedBooking"
          :setSelectedTaxi="setSelectedTaxi"
          :selectedTaxi="selectedTaxi"
          :selectedBooking="selectedBooking"
          v-for="taxi in mapBookingsToTaxi"
          :taxi="taxi"
          @reassign="reassign"
          @edit="edit"
          @copy="copy"
        />
        <tr
          style="max-height: 30px !important; background-color: black !important;"
          v-if="history != null && history.length > 0"
        >
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <HistoryTableRows
          v-for="booking in history"
          v-if="history != null"
          :booking="booking"
          @copy="copy"
          @edit="edit"
        />
      </table>
    </div>
    <div id="searchcontainer">
      <v-layout row align-center>
        <v-flex xs6>
          <TableSearch ref="tableSearch" table="activeTable" />
        </v-flex>
        <p style="display: inline; font-size: 12px;">Hours History&nbsp;&nbsp;</p>
        <input
          @input="hoursToShowChanged"
          style="display: inline; width: 32px; font-size: 12px; background-color: white; padding-left: 4px;"
          type="number"
          v-model="hoursToShow"
        />
      </v-layout>
    </div>
  </div>
</template>

<script>
import ActiveTaxiTableRows from "@/components/overwatch/ActiveTaxiTableRows.vue";
import HistoryTableRows from "@/components/overwatch/HistoryTableRows.vue";
import TableSearch from "@/components/overwatch/TableSearch.vue";
import moment from "moment";

import { Overwatch } from "@/components/util/Overwatch.js";

export default {
  name: "ActiveTrips",
  components: {
    ActiveTaxiTableRows,
    HistoryTableRows,
    TableSearch
  },
  model: {
    prop: "content",
    event: "input"
  },
  props: {
    taxis: Array,
    bookings: Array,
    history: Array,
    selectedTaxi: Number,
    selectedBooking: Number,
    setSelectedTaxi: Function,
    setSelectedBooking: Function,
    hoursToShow: Number
  },
  watch: {
    bookings: function() {
      // console.log("Bookings search");
      this.$refs.tableSearch.searchTable();
    }
  },
  computed: {
    mapBookingsToTaxi: function() {
      var ow = new Overwatch(this.taxis, this.bookings);

      var activeTaxisUnordered = this.taxis.filter(function(taxi) {
        return (
          taxi.state == "pob" ||
          taxi.state == "on_job" ||
          taxi.state == "job_sent" ||
          taxi.has_follow_on_job_offer
        );
      });

      var activeTaxis = ow.sortTaxisByState(activeTaxisUnordered);

      activeTaxis.map(function(t) {
        t.currentBookingTaxi = ow.getCurrentBookingTaxiForTaxi(t.id);
        t.followOnJobs = ow.getAcceptedFollowOnBookingsForTaxi(t);

        // modify booking to have reference to current taxi -- used for assign trip
        if (t.followOnJobs != null) {
          t.followOnJobs.map(function(b) {
            b.currentTaxi = t;
          });
        }
      });

      return activeTaxis;
    }
  },
  data() {
    return {
      ABOUT_TO_CLEAR_TIME: 1
    };
  },
  methods: {
    hoursToShowChanged: function() {
      this.$emit("changeHoursToShow", Number(this.hoursToShow));
    },
    copy: function(booking) {
      this.$emit("copy", booking);
    },
    edit: function(bookingID) {
      this.$emit("edit", bookingID);
    },
    reassign: function(b) {
      this.$emit("reassign", b);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#gridcontainer {
  position: absolute;
  top: 0;
  bottom: 24px;
  left: 0;
  right: 0;
  overflow: auto;
}

#searchcontainer {
  position: absolute;
  width: 100%;
  height: 24px;
  bottom: 0px;
  left: 0;
  padding-top: 1px;
  padding-left: 24px;
  right: 0;
  background-color: #f5f5f5;
}

.upcoming-table {
  font-size: 11px;
  table-layout: fixed;
  width: 100%;
}

th {
  text-align: left;
  color: #10425a;

  overflow: hidden;
  white-space: nowrap;
}

th,
td {
  text-align: left;
  padding-left: 8px;
}

td {
  padding-top: 3px !important;
  padding-bottom: 3px !important;
}

table {
  padding: 4px;
  border-collapse: collapse;
}

ul {
  list-style: none;
  padding-left: 0px;
}

.taxi-list-header {
  color: #10425a;
}

.small-text {
  font-size: 13px;
}
</style>
